




































































import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { NewMessageType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import CTimePicker from '../inputs/CTimePicker.vue'
import MainMixin from '../../mixins/MainMixin'

@Component({
  components: {
    CDatePicker,
    CTimePicker,
  },
})

export default class IncidentReport extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop() shifts!:any

  @Prop() users!:any

  selectedDate = ''

  selectedTime = ''

  get managers() {
    return [{ text: 'Management', value: 'management' }, { text: 'Owner', value: 'owner' }, { text: 'Other', value: 'other' }].concat(this.$store.getters.allManagers)
  }

  get date() {
    const date = dayjs(this.selectedDate).hour(Number(this.selectedTime.split(':')[0])).minute(Number(this.selectedTime.split(':')[1]))
    return date
  }

  types = [
    { text: 'Food Quality', value: 'foodQuality' },
    { text: 'Food Timing', value: 'foodTiming' },
    { text: 'Service Quality', value: 'ServiceQuality' },
    { text: 'Service Timing', value: 'ServiceTiming' },
    { text: 'Equipment Issue', value: 'equipment' },
    { text: 'Stock Issue', value: 'stock' },
    { text: 'Other', value: 'other' },
  ]

  priorities = [
    { text: 'Urgent', value: 5 },
    { text: 'High Priority', value: 4 },
    { text: 'Medium Priority', value: 3 },
    { text: 'Low Priority', value: 2 },
    { text: 'No Longer Applicable', value: 1 },
  ]

  data:NewMessageType = {
    user: '',
    to: '',
    datetime: new Date(),
    contact: { name: '', email: '', phone: '' },
    type: '',
    priority: '',
    message: '',
  }

  presubmit() {

  }

  clearForm() {
    this.data = {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
      to: '',
      datetime: new Date(),
      contact: { name: '', email: '', phone: '' },
      type: '',
      priority: '',
      message: '',
    }
    this.selectedDate = ''
    this.selectedTime = ''
    const observer:any = this.$refs.obs
    const datePicker:any = this.$refs.datepicker
    const timePicker:any = this.$refs.timepicker;
    ([datePicker, timePicker, observer]).forEach(x => x.reset())
  }

  @Watch('datetime')
  dateChange(newDate:Date) {
    this.data.datetime = newDate
  }

  created() {
    if (!this.$store.getters.multiUser) {
      this.data.user = this.$store.getters.uid
    }
  }
}

